import React from "react";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface TiktokLinkProps {
    showText?: boolean;
    iconColor?: string;
}

const TiktokLink: React.FC<TiktokLinkProps> = ({
    showText = false,
    iconColor,
}) => {
    const userId = "@endocomunidad";
    const link_msg = "Síguenos en TikTok";
    const account_link = "https://www.tiktok.com/@endocomunidad";

    return (
        <a href={account_link} target="_blank" rel="noopener noreferrer" title={link_msg}>
            <p>
                <FontAwesomeIcon icon={faTiktok} {...(iconColor ? { color: iconColor } : {})} />
            </p>
            {showText && (
                <p>
                    <span style={{ color: "#fff" }}>{userId}</span>
                </p>
            )}
        </a>
    );
};

export default TiktokLink;